import axios from 'axios'
import baseURL from '@/utils/url'

const http = axios.create({ baseURL, timeout: 30000 })

/** 獲取活動基本信息及報名欄位配置 */
export function getSimpleSign (id) {
  return http.post(`/activity/getSimpleSign?id=${id}&type=1`).then(r => r.data)
}

/** 2.0 網頁報名提交（JSON body） */
export function simpleWebSign (params) {
  return http.post('/activityWeb/simpleWebSign', params).then(r => r.data)
}

/** 1.0 舊版報名提交（form data） */
export function addActivitySignWebNew (params) {
  const fd = new URLSearchParams()
  Object.keys(params).forEach(k => fd.append(k, params[k]))
  return http.post('/activity/addActivitySignWebNew', fd).then(r => r.data)
}

/** 大中小區分級查詢（getActivitySq） */
export function getActivitySq (level, area = '') {
  return http.get(`/activityWeb/getActivitySq?level=${level}&area=${encodeURIComponent(area)}`).then(r => r.data)
}

/** 上傳報名附件，返回 { path, url, fileName, storedName } */
export function uploadSignFile (file) {
  const fd = new FormData()
  fd.append('file', file)
  return http.post('/activityWeb/uploadSignFile', fd, {
    headers: { 'Content-Type': 'multipart/form-data' }
  }).then(r => r.data)
}
